export default __webpack_public_path__ + "static/media/flag.737a72cb.svg";